module.exports = __webpack_public_path__ + "static/media/Arusher-Script.8b5aa082.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arusher-Script.otf
// module id = 3022
// module chunks = 68